var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"variant":_vm.getPkgType(_vm.pkgStatus, _vm.payStatus)}},[_vm._v("\n  "+_vm._s(_vm.getPkgStatusName(_vm.pkgStatus, _vm.payStatus))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }